import { Injectable } from '@angular/core';

import { BaseService } from '../abstracts/base.service';
import { ResultModel } from '../models/result.model';
import { LessonModel } from '../models/lesson.model';
import { DocumentModel } from '../models/document.model';
import { ImportParticipantModel } from '../models/import-participant.model';
@Injectable({
  providedIn: 'root'
})
export class ImportService extends BaseService {

  importStudentForClass(classID:string, file: File) {
    const uploadData = new FormData();
    uploadData.append('ImportFile', file, file.name);
    uploadData.append('ClassID',classID);
    //return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('import/class-student'), uploadData, { reportProgress: true, observe: 'events' });
    return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('import/class-student'), uploadData);
  }

  importParticipantForClass(classID:string, companyID:string, file: File) {
    const uploadData = new FormData();
    uploadData.append('ImportFile', file, file.name);
    uploadData.append('ClassID',classID);
    uploadData.append('CompanyID',companyID);
    //return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('import/class-student'), uploadData, { reportProgress: true, observe: 'events' });
    return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('import/participant'), uploadData);
  }

  importParticipantForTraining(importModel: ImportParticipantModel) {
    const uploadData = new FormData();
    uploadData.append('ImportFile', importModel.ImportFile, importModel.ImportFile.name);
    uploadData.append('TrainingID', importModel.TrainingID);
    uploadData.append('CompanyID', importModel.CompanyID);
    uploadData.append('SetTrainingDays', importModel.SetTrainingDays.toString());
    uploadData.append('StartTime1', importModel.StartTime1);
    uploadData.append('EndTime1', importModel.EndTime1);
    uploadData.append('StartTime2', importModel.StartTime2);
    uploadData.append('EndTime2', importModel.EndTime2);
    uploadData.append('DayAmount', importModel.DayAmount.toString());
    uploadData.append('IncludeSaturday', importModel.IncludeSaturday.toString());
    uploadData.append('IsAfternoonNewGroup', importModel.IsAfternoonNewGroup.toString());
    //return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('import/class-student'), uploadData, { reportProgress: true, observe: 'events' });
    return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('import/participant'), uploadData);
  }

  importParticipantForAssessment(importModel: ImportParticipantModel,array:any=[]) {
    const uploadData = new FormData();
    uploadData.append('ImportFile', importModel.ImportFile, importModel.ImportFile.name);
    uploadData.append('TrainingID', importModel.TrainingID);
    uploadData.append('CompanyID', importModel.CompanyID);
    uploadData.append('StartTime1', importModel.StartTime1);
    uploadData.append('Duration', importModel.Duration.toString());
    uploadData.append('BreakTime', importModel.BreakTime);
    uploadData.append('LunchBreakTime', importModel.LunchBreakTime);
    uploadData.append('IncludeSaturday', importModel.IncludeSaturday.toString());
    uploadData.append('IsAutoGroup', importModel.IsAutoGroup.toString());
    uploadData.append('NumberOfMember', importModel.NumberOfMember.toString());
    uploadData.append('timeArray', JSON.stringify(array));
    return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('import/assessment/participant'), uploadData);
  }

  importInstructor(file: File) {
    const uploadData = new FormData();
    uploadData.append('ImportFile', file, file.name);
    //return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('import/class-student'), uploadData, { reportProgress: true, observe: 'events' });
    return this.httpClient.post<ResultModel<DocumentModel>>(this.getApiUrl('import/instructor'), uploadData);
  }

}
